import i18n from 'src/i18n'
import { EMPTY_STATE_COMMUNITIES } from 'src/assets/svg'
import { useEffect, useState } from 'react'
import Button from '@hotmart/space-lib/dist/components/button'
import { Actions, ComponentNames, Entities, EventNames, ScreenNames } from 'src/utils/datahub/enums'
import useSendDatahubConsume from 'src/hook/useSendDatahubConsume/useSendDatahubConsume'
import { NoSearchResultsProps } from './noSearchResults.types'
import { EmptyStateImage, Wrapper } from './noSearchResults.styles'
import { CommunityCard } from './components'

const NoSearchResults = ({ communities }: NoSearchResultsProps) => {
  const [communitiesLength, setCommunitiesLength] = useState(1)
  const { sendDataHubConsume } = useSendDatahubConsume()

  const communitiesList = communities.slice(0, communitiesLength)
  const hasMoreCommunities = communities.length > communitiesLength

  const handleShowMoreCommunities = () => {
    setCommunitiesLength(communities.length)
    sendDataHubConsume({
      action: Actions.VIEW,
      entity: Entities.COMMUNITY,
      event: {
        eventName: EventNames.CLICK_TO_LOAD_MORE_COMMUNITIES_ON_SEARCH,
        screenName: ScreenNames.COMMUNITY_NO_SEARCH_RESULTS,
        componentName: ComponentNames.NO_SEARCH_RESULTS
      }
    })
  }

  useEffect(() => {
    sendDataHubConsume({
      action: Actions.VIEW,
      entity: Entities.COMMUNITY,
      event: {
        eventName: EventNames.VIEW_TO_EMPTY_STATE_ON_SEARCH,
        screenName: ScreenNames.COMMUNITY_NO_SEARCH_RESULTS,
        componentName: ComponentNames.NO_SEARCH_RESULTS
      }
    })
  }, [])

  return (
    <Wrapper className="_mx-auto _p-4 _text-gray-900">
      <h1 className="_text-3 _font-weight-bold _mb-0">{i18n.t('no_search_results.title')}</h1>

      <div className="_d-flex _flex-column _align-items-center _text-center _pt-10 _pb-7 _border-bottom _border-gray-200">
        <EmptyStateImage
          src={EMPTY_STATE_COMMUNITIES}
          alt={i18n.t('no_search_results.empty_state.title')}
          loading="lazy"
        />

        <h2 className="_text-5 _font-weight-light">
          {i18n.t('no_search_results.empty_state.title')}
        </h2>

        <p className="_text-3 _font-weight-light">
          {i18n.t('no_search_results.empty_state.description')}
        </p>
      </div>

      <section className="_py-7">
        <span className="_text-2 _font-weight-bold _d-block _mb-6">
          {i18n.t('no_search_results.communities_section.title')}
        </span>

        <h2 className="_text-2 _mb-2">
          {i18n.t('no_search_results.communities_section.subtitle')}
        </h2>

        <p
          className="_font-weight-light _mb-0 _font-14"
          dangerouslySetInnerHTML={{
            __html: i18n.t('no_search_results.communities_section.description')
          }}
        />

        <div className="_pt-6">
          {communitiesList?.map((community) => (
            <CommunityCard
              key={community.id}
              community={community}
              border={communities.length > 1}
            />
          ))}
        </div>

        {hasMoreCommunities && (
          <div className="_d-flex _justify-content-center _pt-6">
            <Button
              type="button"
              variation="secondary"
              size="sm"
              onClick={handleShowMoreCommunities}
            >
              {i18n.t('no_search_results.communities_section.show_more_button')}
            </Button>
          </div>
        )}
      </section>
    </Wrapper>
  )
}

export default NoSearchResults
